enum TranslationNamespace {
  CreatorHubHome = 'CreatorDashboard.Home',
  CreatorDocumentationHome = 'CreatorDocumentation.Home',
}

export default TranslationNamespace;
